import { UTILS } from '@cms/tpl';
import { Tag } from 'antd';
import React from 'react';
const ContractStatus = {
  A1: [
    1,
    'Đang kinh doanh',
    <Tag color={UTILS.COLOR.GREEN}>Đang kinh doanh</Tag>,
  ],
  A2: [
    2,
    'Ngừng kinh doanh',
    <Tag color={UTILS.COLOR.YELLOW_ORANGE}>Ngừng kinh doanh</Tag>,
  ],
  A3: [3, 'Hủy', <Tag color={UTILS.COLOR.RED_VIOLET}>Hủy</Tag>],
  A4: [4, 'Xóa', <Tag color={UTILS.COLOR.RED}>Xóa</Tag>],
};
export default ContractStatus;
